import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=0a831740&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&id=0a831740&lang=scss&scoped=true&"
import style1 from "./Question.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a831740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a831740')) {
      api.createRecord('0a831740', component.options)
    } else {
      api.reload('0a831740', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=0a831740&scoped=true&", function () {
      api.rerender('0a831740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/queries/Question.vue"
export default component.exports